import React, { Component } from "react";
import { Button, Form, FormGroup, Label, Input, Col, Row } from 'reactstrap';
import BlockUi from 'react-block-ui';
import { reduxForm } from 'redux-form'
import { connect } from 'react-redux';
import Messages from '../../notifications/Messages'
import Errors from '../../notifications/Errors'
import * as nhomKhachHangAction from './actions'
import * as nhomKhachHangConstant from './constants'
import { storedb } from '../../views/client/storedb'
import { BtnPermissions } from '../../lib/BtnPermissions';
import { ButtonExt } from "../controls/ButtonExt"

class NhomKhachHangEdit extends Component {
  constructor(props) {
    super(props);
    var dbContext = storedb();
    this.state = {
      item: {
        Ten: "",
        Setting: {},
        StoreId: dbContext.getStoreId(),
      },
      formError: {},
      formValid: false,
    };
  }
  getParam = (name) => {
    const queryParamsString = this.props.location.search.substring(1),
      searchParams = new URLSearchParams(queryParamsString);
    return searchParams.get(name);
  }
  handleControlChange = (e) => {
    let { item } = this.state
    item[e.target.name] = e.target.value
    this.setState({ item })
  }
  handleSettingChange = (e) => {
    let { item } = this.state
    const oldState = item.Setting[e.target.name]
    item.Setting[e.target.name] = oldState == 1 ? 0 : 1
    this.setState({ item })
  }
  Cancel = () => {
    this.featchDetail();
  }
  featchDetail = () => {
    const { nhomKhachHangDetailRequest } = this.props
    let nhomKhachHangId = this.getParam("nhomkh");
    var requestData = {
      NhomKhId: nhomKhachHangId || 0
    }
    const callback = (data) => {
      if (data.NhomKhId && data.NhomKhId > 0) {
        data.Setting = data.Setting ? JSON.parse(data.Setting) : {}
        this.setState({
          item: data
        });
      }
    }
    return nhomKhachHangDetailRequest(requestData, callback);
  }
  UpdateNhomKhachHang = () => {
    let formError = {};
    let formValid = true;
    if (!this.state.item.Ten || this.state.item.Ten == "") {
      formError.Ten = 'Bạn chưa nhập tên nhóm khách hàng';
    }
    for (var prp in formError) {
      if (prp && formError[prp] != '') {
        formValid = false;
        break;
      }
    }
    this.setState({ formError, formValid });
    if (formValid) {
      let { item } = this.state
      item.Setting = JSON.stringify(item.Setting);
      const callback = () => {
        setTimeout(this.BackToListNhomKhachHang, 2000)
      }
      this.props.nhomKhachHangUpdateRequest(item, callback);
    }
  }
  BackToListNhomKhachHang = (item, e) => {
    this.props.history.push('/nhomkhachhang');
  }
  componentDidMount() {
    this.featchDetail();
  }
  render() {
    const { formError, item } = this.state;
    const {
      nhomKhachHangEdit: {
        requesting,
        errors,
        messages
      },
    } = this.props
    return (
      <div className="animated fadeIn">
        <BlockUi tag="div" blocking={requesting} >
          <Form>
            <FormGroup>
              <Label className="font-weight-bold" for="nhomKhachHang">Tên nhóm khách hàng</Label>
              <Input type="text" name="Ten" id="nhomKhachHang" 
                placeholder="Tên nhóm" 
                value={item.Ten || ''} 
                onChange={this.handleControlChange.bind(this)} />
              <em className="error invalid-feedback">{formError.Ten}</em>
            </FormGroup>
            <FormGroup tag="fieldset">
              <Label className="font-weight-bold">Tích lũy theo:</Label>
              <FormGroup check>
                <Label check>
                  <Input type="checkbox" 
                    name="TichLuyDiem"
                    value={1}
                    checked={item.Setting["TichLuyDiem"] == 1}
                    onChange={e => this.handleSettingChange(e)} />{' '}
                  Điểm
                </Label>
              </FormGroup>
              <FormGroup check>
                <Label check>
                  <Input type="checkbox" 
                    name="TichLuyDs"
                    value={1}
                    checked={item.Setting["TichLuyDs"] == 1}
                    onChange={e => this.handleSettingChange(e)} />{' '}
                  Doanh số
                </Label>
              </FormGroup>
            </FormGroup>
          </Form>
          <div className="w-100 mb-2 mt-2">
            <ButtonExt btnClass="mr-1"
              color="success"
              iconClass="fa-list"
              displayText="Danh sách"
              btnClick={() => this.BackToListNhomKhachHang()}
              permission={""} />
            <ButtonExt btnClass="mr-1"
              color="primary"
              iconClass="fa-save"
              displayText="Lưu"
              btnClick={() => this.UpdateNhomKhachHang()}
              permission={BtnPermissions.NhomKhachHang.ADD_OR_UPDATE} />
          </div>
        </BlockUi>
        <Row>
          <Col md="12">
            {!requesting && !!errors.length && (
              <Errors errors={errors} />
            )}
            {!requesting && !!messages.length && (
              <Messages messages={messages} />
            )}
          </Col>
        </Row>
      </div>
    )
  }
}
const mapStateToProps = state => ({
  nhomKhachHangEdit: state.nhomKhachHangEdit,
})
const connected = connect(mapStateToProps, {
  nhomKhachHangDetailRequest: nhomKhachHangAction.nhomKhachHangDetailRequest,
  nhomKhachHangUpdateRequest: nhomKhachHangAction.nhomKhachHangUpdateRequest,
  nhomKhachHangListRequest: nhomKhachHangAction.nhomKhachHangListRequest,
})(NhomKhachHangEdit)

const formed = reduxForm({
  form: 'nhomKhachHangEdit',
})(connected)

export default formed;


// WEBPACK FOOTER //
// ./src/views/NhomKhachHang/NhomKhachHangEdit.js